import rates from '../assets/animations/rates.json'
import animationMobileDevelopment from '../assets/animations/MobileDevelopment.json'
import WebDevelopment from '../assets/animations/MobileBrowser.json'
import { Slide } from "react-awesome-reveal";
import ServiceCard from '../components/ServiceCard';
import SideAreaTitle from '../components/SideAreaTitle';
import SkillCard from '../components/SkillCard';
import type { ServiceItem, SkillItem } from '../store/types';

const serviceItems: ServiceItem[] = [
    {
        title: "Web Development",
        description: "Custom websites, e-commerce platforms, blogs, and scalable web solutions with hosting and ongoing maintenance.",
        animationData: WebDevelopment
    },
    {
        title: "App Development",
        description: "Cross-platform mobile app development for iOS and Android, including deployment, updates, and maintenance.",
        animationData: animationMobileDevelopment
    },
    {
        title: "UI | UX",
        description: "Social media management and intuitive UI/UX design for web and mobile",
        animationData: rates
    }
];

const skillItems: SkillItem[] = [
    {
        title: "Programming Languages",
        items: [
            "C",
            "C++",
            "Java",
            "Javascript",
            "Python"
        ]
    },
    {
        title: "WEB DEVELOPMENT",
        items: [
            "SCSS & Bootstrap",
            "JavaScript & jQuery",
            "React.js & React Three Fiber",
            "Electron.js",
            "WordPress Development",
            "Playwright End-to-End Testing"
        ]
    },
    {
        title: "App Development",
        items: [
            "React Native CLI, Expo",
            "Detox End-to-End Testing",
            "Test-Driven Development"
        ]
    },
    {
        title: "Backend Development",
        items: [
            "PHP",
            "Laravel",
            "Node.js"
        ]
    },

    {
        title: "UI/UX Frameworks",
        items: [
            "Adobe XD, Photoshop, Illustrator",
            "Figma"
        ]
    },
    {
        title: "Electronics & Prototyping",
        items: [
            "Arduino",
            "Raspberry Pi"
        ],
    }
];

const Services = () => {

    return (
        <section className="col-lg-9 col-xl-7 fh-100 side-area-container" aria-labelledby="services-page-title">
            <div className="white_box"></div>
            <section className="box_container w-100  pos-z green " aria-labelledby="services-page-title">
                <SideAreaTitle id="services-page-title" title="Services" colorClass="green" />
                <section className="row justify-content-center mb-5" aria-label="Services offered">
                    {serviceItems.map((item) => (
                        <ServiceCard
                            key={item.title}
                            title={item.title}
                            description={item.description}
                            animationData={item.animationData}
                        />
                    ))}
                </section>
                <Slide triggerOnce delay={100}>
                    <h2 id="services-skills-heading" className="pb-3 fw-900  ">
                        <span className="border-bottom green">Skills</span>
                    </h2>
                </Slide>

                <section className='row ' aria-labelledby="services-skills-heading">
                    {skillItems.map((item) => (
                        <SkillCard
                            key={item.title}
                            title={item.title}
                            items={item.items}
                        />
                    ))}
                </section>
            </section>
        </section >

    )
}

export default Services;
